{
  "curates": "Curates: {{kinds}}",
  "forEmail": "For {{email}}",
  "join": "You join {{groups}}",
  "may": "You may: {{permissions}}",
  "notPending": {
    "accepted": "This invitation was used already. Sign in instead.",
    "expired": "This invitation has expired. Ask whoever invited you for a new one.",
    "revoked": "This invitation was withdrawn. Ask whoever invited you for a new one."
  },
  "offer": "{{name}} invited you to DMW.",
  "offerProject": "{{name}} invited you to {{project}}.",
  "ready": "Your account is ready. Sign in.",
  "submit": "Create account",
  "title": "Accept an invitation",
  "token": "Invitation token"
}
